import { render, staticRenderFns } from "./EntradaCompraNewTableComponent.vue?vue&type=template&id=5c48f14c&"
import script from "./EntradaCompraNewTableComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaCompraNewTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports